export function validateReport(report) {
  const issues = [];
  const temperature = Number(report.waterTemperature);
  const minimumDepth = Number(report.minimumDepth);
  const maximumDepth = Number(report.maximumDepth);

  if (!report.reportDate || Number.isNaN(Date.parse(`${report.reportDate}T12:00:00`))) {
    issues.push('Report date is missing or malformed.');
  }

  if (report.waterTemperature && (temperature < 32 || temperature > 110)) {
    issues.push(`Review the water temperature of ${report.waterTemperature}°F.`);
  }

  if (report.minimumDepth && minimumDepth < 0) {
    issues.push('Minimum fishing depth cannot be negative.');
  }

  if (report.maximumDepth && maximumDepth < 0) {
    issues.push('Maximum fishing depth cannot be negative.');
  }

  if (report.minimumDepth && report.maximumDepth && maximumDepth < minimumDepth) {
    issues.push('Maximum fishing depth is lower than minimum fishing depth.');
  }

  if (
    (report.minimumDepth && minimumDepth > 2000) ||
    (report.maximumDepth && maximumDepth > 2000)
  ) {
    issues.push('Review the unusually large fishing depth.');
  }

  if (!report.waterbody.trim()) {
    issues.push('Choose or enter a waterbody.');
  }

  if (!report.species) {
    issues.push('Choose a target species.');
  }

  return issues;
}